var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import moment from 'moment';
import { Expose, Type, Transform, Exclude } from 'class-transformer';
import { KibanaDashboardModel } from '../osd/osd-dashboard';
class Recipients {
    emails = [];
    endpointIds = [];
    // This is so we could hold the whole notification endpoints in the object later on.
    notificationEndpoints;
}
__decorate([
    Exclude(),
    __metadata("design:type", Array)
], Recipients.prototype, "notificationEndpoints", void 0);
class ReportObject {
    type;
    shouldAddObjectLink;
    shouldUseAccountLogo;
    timeRange;
    id;
}
__decorate([
    Expose({ name: 'timeRangeMs' }),
    __metadata("design:type", Number)
], ReportObject.prototype, "timeRange", void 0);
__decorate([
    Expose({ name: 'objectId' }),
    __metadata("design:type", String)
], ReportObject.prototype, "id", void 0);
export class ScheduledReportModel {
    id;
    name;
    description;
    cronSchedule;
    errorMessage;
    deactivatedByServer;
    dashboard;
    timeZone;
    reportObject;
    recipients = new Recipients();
    createdAt;
    updatedAt;
    lastSentAt;
    isActivated;
    userFullName = '';
    updatedBy;
}
__decorate([
    Exclude({ toPlainOnly: true }),
    __metadata("design:type", Boolean)
], ScheduledReportModel.prototype, "deactivatedByServer", void 0);
__decorate([
    Exclude(),
    __metadata("design:type", KibanaDashboardModel)
], ScheduledReportModel.prototype, "dashboard", void 0);
__decorate([
    Type(() => ReportObject),
    __metadata("design:type", ReportObject)
], ScheduledReportModel.prototype, "reportObject", void 0);
__decorate([
    Type(() => Recipients),
    __metadata("design:type", Recipients)
], ScheduledReportModel.prototype, "recipients", void 0);
__decorate([
    Type(() => Date),
    Transform(value => moment(value * 1000), { toClassOnly: true }),
    Transform(value => value?.valueOf(), { toPlainOnly: true }),
    __metadata("design:type", Object)
], ScheduledReportModel.prototype, "createdAt", void 0);
__decorate([
    Type(() => Date),
    Transform(value => moment(value * 1000), { toClassOnly: true }),
    Transform(value => value?.valueOf(), { toPlainOnly: true }),
    __metadata("design:type", Object)
], ScheduledReportModel.prototype, "updatedAt", void 0);
__decorate([
    Type(() => Date),
    Transform(value => moment(value * 1000), { toClassOnly: true }),
    Transform(value => value?.valueOf(), { toPlainOnly: true }),
    __metadata("design:type", Object)
], ScheduledReportModel.prototype, "lastSentAt", void 0);
__decorate([
    Expose({ name: 'activated' }),
    __metadata("design:type", Boolean)
], ScheduledReportModel.prototype, "isActivated", void 0);
__decorate([
    Exclude({ toPlainOnly: true }),
    __metadata("design:type", Object)
], ScheduledReportModel.prototype, "userFullName", void 0);
__decorate([
    Expose({ name: 'userId' }),
    __metadata("design:type", Object)
], ScheduledReportModel.prototype, "updatedBy", void 0);
//# sourceMappingURL=scheduled-report.js.map